import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
	BaseCell,
	BaseHeader,
} from '../../../flights/overview/ui/list/columns/Column';
import { Responsive } from '../../../../ui';
import { columnHeaderStyles } from './shared';

interface IPolicyDescriptionCellProps {
	description?: string;
}

const styles = css`
	display: flex;
	flex: 3;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: none;
	}
`;

const StyledHeader = styled(BaseHeader)`
	${styles}
	${columnHeaderStyles}
`;

const StyledCell = styled(BaseCell)`
	${styles}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: description;
	}
`;

export function Header() {
	return <StyledHeader>Description</StyledHeader>;
}

export function Cell({ description }: IPolicyDescriptionCellProps) {
	return <StyledCell>{description ?? ''}</StyledCell>;
}
